import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import {
  Avatar,
  ListItem,
  ListItemText,
  ListItemAvatar
} from '@mui/material';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';


export default function AvatarCustom({
  primary,
  secondary,
  icon,
  color='primary',
  sx={}
}) {
  const [t] = useTranslation();
  const theme = useTheme();
  const Icon = icon ? icon : <CircleOutlinedIcon/>;

  return (
    <ListItem sx={sx}>
      <ListItemAvatar>
        <Avatar sx={{ backgroundColor: theme.palette.primary.main }}>
          {Icon}
        </Avatar>
      </ListItemAvatar>
      <ListItemText primary={t(primary)} secondary={t(secondary ? secondary : 'common.components.noDataLabel')} />
    </ListItem>
  );
}
